import { Prop, Component, Vue } from 'vue-facing-decorator'
import { clientConfig } from '@/store'
import SkeletonImage from '@/components/core/skeleton-image/SkeletonImage.vue'

@Component({
  components: {
    SkeletonImage,
  },
})
export default class LogoComponent extends Vue {
  /** Optional override for the wrapping CSS class on the rendered element. */
  @Prop className: string | undefined = ''

  get logoSrc(): string {
    return clientConfig.logoSrc
  }

  get logoAlt(): string {
    return clientConfig.logoAlt
  }

  /** Whether to render the <img> tag at all. False → caller should render fallback text. */
  get hasLogo(): boolean {
    return this.logoSrc.length > 0
  }
}
